<template>
    <div>
        <b-sidebar
            v-model="open"
            title="Detalhes do Aluno"
            backdrop-variant="dark"
            width="390px"
            backdrop
            shadow
        >
            <div class="px-3 py-2" v-if="student">
                <dl v-if="matriculation">
                    <dt>
                        Matrícula
                    </dt>
                    <dd>
                        <span v-if="student.matriculation">
                            {{ student.matriculation }}
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Nome
                    </dt>
                    <dd>
                        {{ student.name }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Turma
                    </dt>
                    <dd>
                        <b-badge v-for="item in student.groups" :key="item.id" variant="secondary" class="mr-1">
                            <span v-if="item.name">
                                {{ item.name }}
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </b-badge>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Email
                    </dt>
                    <dd>
                        {{ student.email }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Redações Enviadas
                    </dt>
                    <dd>
                        <span v-if="student.essays_count" class="">
                            <b>{{ student.essays_count }}</b>
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Email Verificado ?
                    </dt>
                    <dd>
                        <span v-if="student.email_verified_at" class="text-success">
                            Validado {{ student.email_verified_at | moment('from', 'now') }}
                        </span>
                        <span v-else class="text-danger">
                            Não Validado
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Data de Nascimento
                    </dt>
                    <dd>
                        <span v-if="student.birth" >
                            {{ student.birth | moment('DD/MM/YYYY') }}
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Telefone
                    </dt>
                    <dd>
                        <span v-if="student.phone" >
                            {{ student.phone }}
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Gênero
                    </dt>
                    <dd>
                        <span v-if="student.genre" >
                            <span v-if="student.genre === 'M'">
                                Masculino
                            </span>
                            <span v-if="student.genre === 'F'">
                                Feminino
                            </span>
                            <span v-if="student.genre === 'MC'">
                                Mulher Cis
                            </span>
                            <span v-if="student.genre === 'MT'">
                                Mulher Trans
                            </span>
                            <span v-if="student.genre === 'HC'">
                                Homem Cis
                            </span>
                            <span v-if="student.genre === 'HT'">
                                Homem Trans
                            </span>
                            <span v-if="student.genre === 'NB'">
                                Não-Binárie
                            </span>
                            <span v-if="student.genre === 'O'">
                                Outro
                            </span>
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Observação
                    </dt>
                    <dd>
                        <span v-if="student.observation" >
                            {{ student.observation }}
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Criado
                    </dt>
                    <dd>
                        {{ student.created_at | moment('from', 'now') }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Última Alteração
                    </dt>
                    <dd>
                        {{ student.updated_at | moment('from', 'now') }}
                    </dd>
                </dl>
            </div>

            <template #footer v-if="student">
                <div class="d-flex bg-light text-dark align-items-center border-top px-3 py-2">
                    <div class="mr-auto">

                        <a href="#" class="mr-3" v-b-tooltip.hover title="Editar Aluno" @click="editStudent">
                            <i class="fas fa-pencil-alt mr-1"></i> Editar
                        </a>

                        <a href="#" class=" text-danger" v-b-tooltip.hover title="Excluir Aluno" @click="destroyStudent">
                            <i class="fas fa-trash-alt mr-1"></i> Excluir
                        </a>

                    </div>
                </div>
            </template>
        </b-sidebar>

        <!-- Destroy -->
        <destroy @destroyed="load"></destroy>

        <!-- Edit -->
        <edit @updated="load" :matriculation="matriculation" :genre-advanced="genreAdvanced"></edit>

    </div>
</template>

<script>
import Destroy from "./Destroy";
import Edit from "./Edit";

export default {
    components: {
        Destroy,
        Edit
    },
    props: ['matriculation', 'genreAdvanced'],
    data() {
        return {
            open: false,
            student: null
        }
    },
    created() {
        this.$root.$on('studentShowDetail', (student) => {
            this.student = student
            this.open = true
        })
    },
    methods: {

        load() {
            this.$emit('load')
            this.open = false
        },

        editStudent() {
            this.$root.$emit('editStudent', this.student)
        },

        destroyStudent() {
            this.$root.$emit('destroyStudent', this.student)
        },

    }
}
</script>

<style scoped>

</style>
